import {_, React, observable, computed, action, classNames} from '@api'
import {JiraUrlsStore} from '@stores'
import {} from '@modules'
import {synchronizeStores} from '@stores/SynchronizeStores'

/// region Store

export class JiraStore {
  constructor() {
    synchronizeStores(() => {
    this.urls = new JiraUrlsStore(this)
    })
  }

  urls : JiraUrlsStore


  @observable mustHaveAtLeastOneObservable = true
}

export const JiraStoreContext = React.createContext<JiraStore>(null)
export const useJiraStore = () => React.useContext(JiraStoreContext)

/// endregion

export const jira = new JiraStore()





// WEBPACK FOOTER //
// ./src/stores/jira/JiraStore.ts